import { gql } from '@apollo/client';

import {
  CreateSurveySignedUploadUrlDocument,
  type CreateSurveySignedUploadUrlMutation,
  type CreateSurveySignedUploadUrlMutationVariables,
  CreateSignedUploadUrlDocument,
  type CreateSignedUploadUrlMutation,
  type CreateSignedUploadUrlMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation CreateSurveySignedUploadUrl($input: CreateSignedUrlInput!) {
      createSurveySignedUploadUrl(input: $input) {
        url
        publicUrl
        path
      }
    }
  `;
}

export const CREATE_SURVEY_SIGNED_UPLOAD_URL =
  CreateSurveySignedUploadUrlDocument;
export type {
  CreateSurveySignedUploadUrlMutation,
  CreateSurveySignedUploadUrlMutationVariables,
};

if (false) {
  gql`
    mutation CreateSignedUploadUrl($input: CreateSignedUrlWithOrgInput!) {
      createSignedUploadUrl(input: $input) {
        url
        publicUrl
        path
      }
    }
  `;
}

export const CREATE_SIGNED_UPLOAD_URL = CreateSignedUploadUrlDocument;
export type {
  CreateSignedUploadUrlMutation,
  CreateSignedUploadUrlMutationVariables,
};
